import { Injector, NgModule } from '@angular/core';
import { CamelResponseTransformerInterceptor, SnakeRequestTransformerInterceptor, UbudHttpModule } from '@ubud/http';
import { LemsarApiClient } from '@lemsar/api/client';
import { apiServiceFactory } from '@lemsar/api/factories/api-client.factory';
import { HttpClient } from '@angular/common/http';
import { LEMSAR_API_INTERCEPTORS } from '@lemsar/api/interceptor';
import { RequestForSubmitTransformerInterceptor } from '@lemsar/api/interceptors/for-submit-transformer.interceptor';
import { ErrorNotificatorInterceptor } from '@lemsar/api/interceptors/error-notificator.interceptor';
import { AuthInterceptor } from '@naker/naco';

@NgModule({
    imports: [UbudHttpModule],
    providers: [
        {
            provide: LemsarApiClient,
            useFactory: apiServiceFactory,
            deps: [HttpClient, Injector],
        },
        {
            provide: LEMSAR_API_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: LEMSAR_API_INTERCEPTORS,
            useClass: CamelResponseTransformerInterceptor,
            multi: true,
        },
        {
            provide: LEMSAR_API_INTERCEPTORS,
            useClass: RequestForSubmitTransformerInterceptor,
            multi: true,
        },
        {
            provide: LEMSAR_API_INTERCEPTORS,
            useClass: SnakeRequestTransformerInterceptor,
            multi: true,
        },
        {
            provide: LEMSAR_API_INTERCEPTORS,
            useClass: ErrorNotificatorInterceptor,
            multi: true,
        },
    ],
})
export class LemsarApiModule {}



// WEBPACK FOOTER //
// ./src/lemsar/api/api.module.ts